import { useNavigate } from 'react-router-dom';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';
import { t } from 'i18next';
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function CourseManageTabs({ currentModuleId, courseId, selectedTab }) {
  const navigate = useNavigate();
  const { abilities } = usePlatformAbilities();

  const handleTabChange = value => {
    navigate(`/curso/admin/gerenciar/${courseId}/${currentModuleId}/${value}/d`);
  };

  return (
    <Tabs
      value={selectedTab}
      onValueChange={handleTabChange}
      className="mb-8"
    >
      <TabsList>
        <TabsTrigger value="disciplinas-e-aulas">{t('courses.toggleDisciplineLessons')}</TabsTrigger>
        {abilities?.['cursos-ativ-complementar'] && <TabsTrigger value="atividades">{t('courses.toggleActivity')}</TabsTrigger>}
        {abilities?.['cursos-materiais'] && <TabsTrigger value="materiais">{t('courses.toggleMaterials')}</TabsTrigger>}
        {abilities?.['avaliacoes-apostilas'] && <TabsTrigger value="apostilas">{t('courses.toggleQuestionBooks')}</TabsTrigger>}
      </TabsList>
    </Tabs>
  );
}
